import { useCallback, useEffect, useState } from "react";
import $api from "@/zapi-frontend/shared/api/axios";
import { toast } from "sonner";
import { TGetProjectResponse } from "@/zapi-frontend/shared/types/projects";

export function useProject(id: string | null) {
  const [project, setProject] = useState<TGetProjectResponse | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  const fetchProject = useCallback(
    async (options?: { silent?: boolean }) => {
      if (!id) return;
      if (!options?.silent) setLoading(true);
      try {
        const r = await $api.get<{ data: TGetProjectResponse }>(`/projects/${id}`);
        setProject(r.data.data);
      } catch {
        if (!options?.silent) toast.error("Failed to load stages");
      } finally {
        if (!options?.silent) setLoading(false);
      }
    },
    [id]
  );

  useEffect(() => {
    void fetchProject();
  }, [fetchProject]);

  const optimisticRename = useCallback((versionId: string, newName: string) => {
    setProject((prev) =>
      prev
        ? {
            ...prev,
            versionDisplayName: versionId === String(prev.id) ? newName : prev.versionDisplayName,
            versions: prev.versions?.map((v) => (v.id === versionId ? { ...v, name: newName } : v))
          }
        : prev
    );
  }, []);

  return { project, loading, refetch: fetchProject, optimisticRename };
}
